
import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule, SharedModule],
    templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
    @Input() collapsed: boolean = false;
    userName: string = 'User';
    settingsOpen: boolean = false;

    constructor(private _authService: AuthService) {}

    ngOnInit(): void {
        const user = this._authService.getCurrentUser();
        if (user) {
            this.userName = user.name || user.username || 'User';
        }
    }

    toggleSettings(event: Event): void {
        event.preventDefault();
        this.settingsOpen = !this.settingsOpen;
    }
}
